import Vue from 'vue'
import App from './views/App.vue'
import store from './store'
import router from './router'

import SvgIcon from './components/common/SvgIcon'
import Spinner from './components/common/Spinner'
import VueKeycloakJs from './plugins/sso/keycloak'
import ElementUI from 'element-ui'
import 'element-ui/packages/theme-chalk/lib/index.css'

import VeeValidate from 'vee-validate'
import formRules from '@/plugins/form/rulesValidation'
import isURL from 'validator/lib/isURL'
import isEmail from 'validator/lib/isEmail'
import isAscii from 'validator/lib/isAscii'

import Draggable from 'vuedraggable'
import * as ModalDialogs from 'vue-modal-dialogs'

import '@/styles/main.scss'
// refers to components/ECharts.vue in webpack
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
//- https://echarts.apache.org/examples/en/index.html

// import ECharts modules manually to reduce bundle size
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart, PieChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, ToolboxComponent } from 'echarts/components'

import 'echarts/theme/macarons'
import 'echarts/theme/roma'
import 'echarts/lib/component/tooltip'

use([CanvasRenderer, BarChart, GridComponent, TooltipComponent, LineChart, PieChart, ToolboxComponent])

// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/vue'

Vue.component('svgIcon', SvgIcon)
Vue.component('spinner', Spinner)

Vue.component('draggable', Draggable)

// ELement
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })

Vue.use(ModalDialogs)

//print current version
import { version } from '../package.json'
// eslint-disable-next-line
console.info(version)

// Matomo
// https://github.com/AmazingDreams/vue-matomo

/*
import VueMatomo from 'vue-matomo'

if (process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'preprod') {
    const prod_siteId = 2
    const preprod_siteId = 3
    Vue.use(VueMatomo, {
        host: 'https://weborama.matomo.cloud/',
        siteId: process.env.VUE_APP_ENV === 'production' ? prod_siteId : preprod_siteId,

        // Changes the default .js and .php endpoint's filename
        // Default: 'matomo'
        trackerFileName: 'matomo',

        // Overrides the autogenerated tracker endpoint entirely
        // Default: undefined
        // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

        // Overrides the autogenerated tracker script path entirely
        // Default: undefined
        // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

        // Enables automatically registering pageviews on the router
        router: router,

        // Enables link tracking on regular links. Note that this won't
        // work for routing links (ie. internal Vue router links)
        // Default: true
        enableLinkTracking: true,

        // Require consent before sending tracking information to matomo
        // Default: false
        requireConsent: false,

        // Whether to track the initial page view
        // Default: true
        trackInitialView: true,

        // Run Matomo without cookies
        // Default: false
        disableCookies: false,

        // Require consent before creating matomo session cookie
        // Default: false
        requireCookieConsent: false,

        // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
        // Default: false
        enableHeartBeatTimer: false,

        // Set the heartbeat timer interval
        // Default: 15
        heartBeatTimerInterval: 15,

        // Whether or not to log debug information
        // Default: false
        debug: false,

        // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
        // Default: undefined
        userId: undefined,

        // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
        // Default: undefined, example '*.example.com'
        cookieDomain: undefined,

        // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
        // Default: undefined, example: '*.example.com'
        domains: undefined,

        // A list of pre-initialization actions that run before matomo is loaded
        // Default: []
        // Example: [
        //   ['API_method_name', parameter_list],
        //   ['setCustomVariable','1','VisitorType','Member'],
        //   ['appendToTrackingUrl', 'new_visit=1'],
        //   etc.
        // ]
        preInitActions: [],

        // A function to determine whether to track an interaction as a site search
        // instead of as a page view. If not a function, all interactions will be
        // tracked as page views. Receives the new route as an argument, and
        // returns either an object of keyword, category (optional) and resultsCount
        // (optional) to track as a site search, or a falsey value to track as a page
        // view.
        // Default: false, i.e. track all interactions as page views
        // Example: (to) => {
        //   if (to.query.q && to.name === 'search') {
        //     return { keyword: to.query.q, category: to.params.category }
        //   } else {
        //    return null
        //   }
        // }
        trackSiteSearch: false
    })
}*/

//Charts
Vue.component('v-chart', ECharts)

// form validatiom
Vue.use(formRules)
Vue.use(VeeValidate)
const urlFixRule = value => {
    return isURL(value, {
        require_protocol: true,
        protocols: ['https']
    })
}
const emailCcFixRule = value => {
    return isEmail(value, { allow_utf8_local_part: false })
}

const isAsciiRule = {
    getMessage: () => 'Only ASCII characters are allowed',
    validate: value => isAscii(value)
}

VeeValidate.Validator.extend('url', urlFixRule)
VeeValidate.Validator.extend('email', emailCcFixRule)
VeeValidate.Validator.extend('ascii', isAsciiRule)

Vue.use(VueKeycloakJs, {
    config: {
        url: process.env.VUE_APP_CONNECT_URL + '/auth',
        clientId: process.env.VUE_APP_CONNECT_CLIENTID,
        realm: process.env.VUE_APP_CONNECT_REALM,
        logout: process.env.VUE_APP_PORTAL_URL + '/logout'
    },
    onReady: () => {
        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#vuejs-app')
    }
})

Vue.config.devtools = true
Vue.config.debug = true

Vue.config.productionTip = false

if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        Vue,
        dsn: 'https://a61dee81275c9247938c0c6a469a4cf2@logging.nereides.weborama.com/28',
        integrations: [
            // new Integrations.Vue({ Vue, attachProps: true }),
            Sentry.browserTracingIntegration({ router }),
        ],
        environment: process.env.VUE_APP_ENV,
        release: version
    })
}
